import { createClient } from '@supabase/supabase-js'

// Create a single supabase client for interacting with your database
const supabase = createClient(
    'https://xfrselwigizegyokzabo.supabase.co'
    ,
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhmcnNlbHdpZ2l6ZWd5b2t6YWJvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg3MTI3NzAsImV4cCI6MjA2NDI4ODc3MH0.wMCgmycqwGUWcYAsbx40vyH4l0I4v_c0P-HsGMW9yOc'
)

export default supabase